<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12" md="10">
        <v-row>
          <v-col cols="12" md="6">
            <AutocompleteSubjectGroup
              return-object
              label="Bộ môn"
              deletable-chips
              dense
              outlined
              v-model="subjectGroup"
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4">
            <div class="d-flex justify-space-between align-center pt-1">
              <v-checkbox class="mt-0" label="Chính khóa" v-model="coreCurriculum"></v-checkbox>
              <v-checkbox class="mt-0" label="Bổ trợ" v-model="extraCurriculum"></v-checkbox>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <AutocompleteGrade
              return-object
              item-text="title"
              clearable
              clear-icon="mdi-close"
              outlined
              label="Khối"
              item-value="id"
              dense
              deletable-chips
              hide-details
              @change="gradeChanged"
            />
          </v-col>
          <v-col cols="12" md="6">
            <AutocompleteDivision
              v-model="division"
              item-text="name"
              item-value="title"
              clear-icon="mdi-close"
              clearable
              label="Phân ban"
              outlined
              dense
              deletable-chips
              hide-details
              @change="divisionChanged"
              :filter="divisionFilter"
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="2" class="align-end d-flex">
        <v-btn
          class="search-button"
          dark
          @click="onFilterChanged"
          color="primary"
          outlined
          :class="{ 'px-2': windowWidth < 1100 }"
        >
          Tìm kiếm
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import AutocompleteSubjectGroup from '@/components/basic/input/AutocompleteSubjectGroup.vue'
import AutocompleteDivision from '@/components/basic/input/AutocompleteDivision.vue'
import AutocompleteGrade from '@/components/basic/input/AutocompleteGrade.vue'
import { get, isEmpty } from 'lodash'

export default {
  components: {
    AutocompleteSubjectGroup,
    AutocompleteDivision,
    AutocompleteGrade
  },
  data: () => ({
    subject: null,
    query: '',
    division: '',
    grade: null,
    dialog: true,
    type: null,
    extraCurriculum: false,
    coreCurriculum: false,
    subjectGroup: null
  }),
  props: {
    windowWidth: Number
  },
  computed: {
    ...mapState('constant', ['subjectsStatus', 'subjectTypes']),

    divisionFilter() {
      return { academicLevel: get(this.grade, 'academicLevel.id') }
    },
    subjectTitleFilter() {
      return {
        grade: get(this.grade, 'id'),
        division: this.division
      }
    }
  },
  methods: {
    onFilterChanged() {
      let params = {
        subjectGroup: get(this.subjectGroup, 'id'),
        grade: get(this.grade, 'id'),
        division: this.division,
        id: get(this.subject, 'id')
      }
      if (this.coreCurriculum && this.extraCurriculum) params['type_in'] = ['coreCurriculum', 'extraCurriculum']
      else if (this.coreCurriculum) params.type = 'coreCurriculum'
      else if (this.extraCurriculum) params.type = 'extraCurriculum'
      else params['type_in'] = ['coreCurriculum', 'extraCurriculum']
      this.$emit('onFilterChanged', params)
    },
    divisionChanged(division) {
      if (this.subject && !isEmpty(division) && this.subject.division.id !== division) {
        this.subject = null
      }
    },
    gradeChanged(grade) {
      if (grade && this.grade && get(this.grade, 'academicLevel.id') !== get(grade, 'academicLevel.id')) {
        this.division = ''
      }
      if (grade && this.subject && get(grade, 'id') !== this.subject.grade.id) {
        this.subject = null
      }
      this.grade = grade
    },
    reset() {
      this.query = ''
      this.grade = null
      this.division = ''
      this.subject = null
    }
  }
}
</script>

<style scoped></style>
